import axios from 'axios';
import apiConfig from '../../api.config';

export default function updatePoliceAlloggiati({ hotelId, body }) {
  const {
    host,
    URIs: { policeReportAlloggiati },
  } = apiConfig;

  const uri = `${host}${policeReportAlloggiati.replace(':hotelId', hotelId)}`;

  return axios
    .post(uri, body, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(res => {
      return res.data;
    });
}
